import { SVGProps } from 'react';

export function Arrow({ ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect width="24" height="24" rx="8" fill="white" />
			<g id="Icon" clipPath="url(#clip0_7446_13221)">
				<path
					id="Vector"
					d="M6.61627 2.99006C7.10627 2.50006 7.89627 2.50006 8.38627 2.99006L16.6963 11.3001C17.0863 11.6901 17.0863 12.3201 16.6963 12.7101L8.38627 21.0201C7.89627 21.5101 7.10627 21.5101 6.61627 21.0201C6.12627 20.5301 6.12627 19.7401 6.61627 19.2501L13.8563 12.0001L6.60627 4.75006C6.12627 4.27006 6.12627 3.47006 6.61627 2.99006Z"
					fill="#C8102E"
				/>
			</g>
		</svg>
	);
}
